import {Card, Col, Row} from "reactstrap";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {ToCustomDecimal} from "../../AppSystem/Helpers/ToCustomDecimal";

export function CustomReimbursementMileageView({data, editMode, onClickDelete, onClickEdit}) {
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);

    const mileageSignature = `${data?.id ?? ''}|${data?.from ?? ''}|${data?.to ?? ''}|${data?.km ?? 0}|${data?.totalAmount ?? data?.amount ?? 0}|${
        Array.isArray(data?.passengers) && data.passengers.length > 0
            ? `${data.passengers[0]?.quantity ?? 0}|${data.passengers[0]?.km ?? 0}|${data.passengers[0]?.amount ?? 0}`
            : ''
    }`;

    React.useEffect(() => {
        setIsExpanded(false);
    }, [mileageSignature]);

    const isReadOnlyProceeding = editMode === undefined && !onClickDelete && !onClickEdit;

    if (isReadOnlyProceeding) {
        const passenger = Array.isArray(data?.passengers) && data.passengers.length > 0 ? data.passengers[0] : null;
        const total = data?.totalAmount ?? data?.amount ?? 0;

        return (
            <div className="reimbursement-section-card">
                <div className="reimbursement-section-title rokkitt-font">{t("reimbursement.mileageCompensation")}</div>
                <div className="reimbursement-fields">
                    <div className="reimbursement-field">
                        <div className="reimbursement-field-label">{t("reimbursement.origin")}</div>
                        <div className="reimbursement-field-value">{data?.from || "-"}</div>
                    </div>
                    <div className="reimbursement-field">
                        <div className="reimbursement-field-label">{t("reimbursement.destination")}</div>
                        <div className="reimbursement-field-value">{data?.to || "-"}</div>
                    </div>
                    <div className="reimbursement-divider" />
                    <div className="reimbursement-field">
                        <div className="reimbursement-field-label">{t("modelLabel.kilometers")}</div>
                        <div className="reimbursement-field-value">
                            {data?.km ?? 0} km = {ToCustomDecimal(data?.amount ?? 0)} kr
                        </div>
                    </div>
                    {passenger && (
                        <>
                            <div className="reimbursement-divider" />
                            <div className="reimbursement-field">
                                <div className="reimbursement-field-label">{t("reimbursement.numberPassengers")}</div>
                                <div className="reimbursement-field-value">{passenger?.quantity ?? 0}</div>
                            </div>
                            <div className="reimbursement-field">
                                <div className="reimbursement-field-label">{t("modelLabel.totalDistance")}</div>
                                <div className="reimbursement-field-value">
                                    {passenger?.km ?? 0} km = {ToCustomDecimal(passenger?.amount ?? 0)} kr
                                </div>
                            </div>
                        </>
                    )}
                    <div className="reimbursement-divider" />
                    <div className="crv-total-row">
                        <div className="reimbursement-field-label">{t("modelLabel.total")}</div>
                        <div className="reimbursement-big-value">
                            {ToCustomDecimal(total)} {t("modelLabel.kr")}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const totalAmount = data?.totalAmount ?? data?.amount ?? 0;
    const canEdit = data?.status === 'Förslag' && editMode !== true;
    const passenger = Array.isArray(data?.passengers) && data.passengers.length > 0 ? data.passengers[0] : null;

    return (
        <div className="crv-card-outer">
            <div className="crv-header" onClick={() => setIsExpanded(prev => !prev)}>
                <div className="crv-header-left">
                    <i className="bx bx-car crv-header-icon" />
                    <span className="crv-header-label">{t('reimbursement.mileage')}</span>
                </div>
                <div className="crv-header-right">
                    {!isExpanded && (
                        <span className="crv-header-amount">{ToCustomDecimal(totalAmount)} kr</span>
                    )}
                    <i className={`bx ${isExpanded ? "bx-chevron-up" : "bx-chevron-down"} crv-chevron`} />
                </div>
            </div>

            <div className="crv-collapse" style={{ maxHeight: isExpanded ? "400px" : "0px" }}>
                <div className="crv-collapse-inner">
                    <div className={`crv-inner-card ${canEdit ? "crv-inner-card-with-buttons" : ""}`}>
                        <div className="crv-row-mb">
                            <span className="crv-label">{data?.from}</span>
                            <span className="crv-label">-</span>
                            <span className="crv-label">{data?.to}</span>
                        </div>

                        {passenger && (
                            <div className="crv-label crv-row-mb">
                                {t('reimbursement.numberPassengers')}: {passenger.quantity}
                            </div>
                        )}

                        <div className="crv-separator" />

                        <div className="crv-row">
                            <span className="crv-label-bold">{t('modelLabel.amount')}:</span>
                            <span className="crv-value-bold">{ToCustomDecimal(totalAmount)} kr</span>
                        </div>
                    </div>

                    {canEdit && (
                        <div className="crv-action-buttons">
                            <button type="button" onClick={onClickDelete} className="crv-btn-action">
                                <i className="bx bx-trash-alt crv-icon-delete" />
                            </button>
                            <button type="button" onClick={onClickEdit} className="crv-btn-action">
                                <i className="bx bxs-pencil crv-icon-edit" />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}